module.exports = __webpack_public_path__ + "img/bg_tf.ab003352.webp";